import { useQuery } from '@tanstack/react-query';

import { fetchClaimReasonList } from '../../data-provider/select-options/claim-reason';

export const useGetClaimReason = () => {
  return useQuery({
    queryFn: () => fetchClaimReasonList(),
    queryKey: ['over-charge-claim-reason-list'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
